import { render, staticRenderFns } from "./BdrSolveConflicts.vue?vue&type=template&id=1a86478a&"
import script from "./BdrSolveConflicts.vue?vue&type=script&lang=js&"
export * from "./BdrSolveConflicts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports